import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ids } from "../ids/ids";

import { collection, getDocs } from "firebase/firestore";
import { db } from "./Firebase";
import TopModule from "./Top.module.css";

const Top = () => {
  const [userLogin, setUserLogin] = useState({
    fst: "",
    snd: "",
    srd: "",
    fth: "",
  });

  const [streamerNames, setStreamerNames] = useState({
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    7: [],
    8: [],
    9: [],
    10: [],
    11: [],
    12: [],
    13: [],
    14: [],
    15: [],
    16: [],
    17: [],
    18: [],
    19: [],
  });

  const [url, setUrl] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "stream"));
      querySnapshot.forEach((doc) => {
        setStreamerNames((pre) => {
          return { ...pre, [doc.id]: doc.data().names };
        });
      });
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fst = localStorage.getItem("urltext_1")
      ? localStorage.getItem("urltext_1")
      : "";
    const snd = localStorage.getItem("urltext_2")
      ? localStorage.getItem("urltext_2")
      : "";
    const srd = localStorage.getItem("urltext_3")
      ? localStorage.getItem("urltext_3")
      : "";
    const fth = localStorage.getItem("urltext_4")
      ? localStorage.getItem("urltext_4")
      : "";

    setUserLogin({ fst, snd, srd, fth });
    return () => {};
  }, []);

  useEffect(() => {
    const urltext1 = userLogin.fst ? `/${userLogin.fst}` : "";
    const urltext2 = userLogin.snd ? `/${userLogin.snd}` : "";
    const urltext3 = userLogin.srd ? `/${userLogin.srd}` : "";
    const urltext4 = userLogin.fth ? `/${userLogin.fth}` : "";
    setUrl(
      `https://onegoup.com/multi/#/streams${urltext1}${urltext2}${urltext3}${urltext4}`
    );
  }, [userLogin]);

  const handleChange = (input) => (e) => {
    const userID = e.target.value.replace("https://www.twitch.tv/", "");
    setUserLogin((pre) => {
      return { ...pre, [input]: userID.trim() };
    });
  };

  const [styleEffect, setStyleEffect] = useState(
    "flex items-center mr-3 hover:bg-violet-100 rounded-lg text-white"
  );

  const copyUrl = () => {
    navigator.clipboard.writeText(url).then(
      () => {
        setStyleEffect(
          "flex items-center mr-3 animate-shake-vertical rounded-lg text-white"
        );
        setTimeout(() => {
          setStyleEffect(
            "flex items-center mr-3 hover:bg-violet-100 rounded-lg text-white"
          );
        }, 1000);
      },
      (err) => {}
    );
  };

  const imageClik = (input) => {
    setUserLogin({
      fst: streamerNames[input][0] ? streamerNames[input][0] : "",
      snd: streamerNames[input][1] ? streamerNames[input][1] : "",
      srd: streamerNames[input][2] ? streamerNames[input][2] : "",
      fth: streamerNames[input][3] ? streamerNames[input][3] : "",
    });
  };

  return (
    <div className="min-h-screen relative pt-10 bg-gradient-to-br from-pink-300 via-purple-300 to-indigo-400">
      <div className="flex justify-center mb-10">
        <div className="animate-tracking-in-expand text-4xl">
          <p className={TopModule.googlefont}>ツイッチ　マルチ</p>
        </div>
      </div>
      <div className="bg-black shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col my-2">
        <div className="mx-3 md:flex mb-6">
          <div className="md:w-1/2 px-3 mb-6 md:mb-0">
            <label
              className="block uppercase tracking-wide text-white text-xs font-bold mb-2"
              htmlFor="grid-first-name"
            >
              1st
            </label>
            <input
              className="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
              type="text"
              placeholder="1st"
              onChange={handleChange("fst")}
              value={userLogin["fst"]}
            />
          </div>
          <div className="md:w-1/2 px-3">
            <label
              className="block uppercase tracking-wide text-white text-xs font-bold mb-2"
              htmlFor="grid-last-name"
            >
              2nd
            </label>
            <input
              className="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4"
              type="text"
              placeholder="2nd"
              onChange={handleChange("snd")}
              value={userLogin["snd"]}
            />
          </div>
        </div>
        <div className="mx-3 md:flex mb-6">
          <div className="md:w-1/2 px-3 mb-6 md:mb-0">
            <label
              className="block uppercase tracking-wide text-white text-xs font-bold mb-2"
              htmlFor="grid-first-name"
            >
              3rd
            </label>
            <input
              className="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 mb-3"
              type="text"
              placeholder="3rd"
              onChange={handleChange("srd")}
              value={userLogin["srd"]}
            />
          </div>
          <div className="md:w-1/2 px-3">
            <label
              className="block uppercase tracking-wide text-white text-xs font-bold mb-2"
              htmlFor="grid-last-name"
            >
              4th
            </label>
            <input
              className="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4"
              type="text"
              placeholder="4th"
              onChange={handleChange("fth")}
              value={userLogin["fth"]}
            />
          </div>
        </div>
        <div className="flex justify-center mb-6">
          <Link to="/streams" state={{ ...userLogin }}>
            {/* <button className="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 drop-shadow-2xl hover:scale-125">
              <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                画面作成
              </span>
            </button> */}
            <button className={TopModule.button}> 画面作成</button>
          </Link>
        </div>
        <div className="hidden md:flex md:items-center md:px-6">
          <div className=" hover:cursor-pointer hover:scale-125">
            <div className={styleEffect} onClick={copyUrl}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6 mt-auto mb-auto "
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"
                />
              </svg>
              <div className="mt-auto mb-auto mr-1">copy</div>
            </div>
          </div>
          <input
            className="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4"
            type="text"
            placeholder="url"
            value={url}
            readOnly={true}
          />
        </div>
      </div>
      <div className="md:flex mt-10 mb-10">
        <div className="flex justify-around md:w-full mb-5 md:mb-0">
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[0]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(0);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[1]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(1);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[2]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(2);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[3]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(3);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[4]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(4);
            }}
          />
        </div>
        <div className="flex justify-around md:w-full mb-5 md:mb-0">
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[5]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(5);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[6]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(6);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[7]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(7);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[8]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(8);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[9]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(9);
            }}
          />
        </div>
      </div>
      <div className="md:flex mb-3">
        <div className="flex justify-around md:w-full mb-5 md:mb-0">
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[10]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(10);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[11]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(11);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[12]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(12);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[13]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(13);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[14]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(14);
            }}
          />
        </div>
        <div className="flex justify-around md:w-full mb-5 md:mb-0">
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[15]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(15);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[16]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(16);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[17]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(17);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[18]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(18);
            }}
          />
          <img
            className="rounded-full border-4 border-violet-400 drop-shadow-lg hover:cursor-pointer hover:scale-125"
            src={ids[19]["box_art_url"]}
            alt="Logo"
            onClick={() => {
              imageClik(19);
            }}
          />
        </div>
      </div>
      <div className="absolute left-1/2  transform -translate-x-1/2 bottom-3">
        <div>© 2018 yaaboo@onegoup.com</div>
      </div>
    </div>
  );
};

export default Top;
